<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>What if I have multiple settlements?<Caret /></summary>
  <p>
    Any claim you have that’s settled and ready for payment will clearly show this on your JLG portal home page near the
    claim itself, with instructions on how to receive payment. If you have multiple claims that have settled, we’ll walk
    you through each one individually, to easily receive your payment.
  </p>
  <p>
    If you have a claim that hasn’t yet settled, you won’t see a settlement task or any links to receive payment. If
    those claims come to a resolution, we’ll notify you for next steps.
  </p>
</details>
